// The ID schema-flip on ExportJob removed reportId — the row's id IS the ux_id
// now. Kept as a hand-rolled DTO (rather than a slice of MyExportJobsQuery) so
// the table types stay decoupled from Apollo's __typename / Maybe<T> noise.
export interface ExportJobRaw {
  id: string;
  reportType: string;
  reportParams?: string | null;
  status: string;
  access: string;
  progress: number;
  createdAt: string;
  expiresAt: string;
  completedAt?: string | null;
  failedAt?: string | null;
  canceledAt?: string | null;
  errorMessage?: string | null;
  requestedBy: { id: string; name: string; email: string };
}

export interface MyExportJobsData {
  myExportJobs: ExportJobRaw[];
}

export interface ReportRow extends ExportJobRaw {
  objectLabel: string;
  formatLabel: string;
}

const OBJECT_LABEL_MAP: Record<string, string> = {
  assessment: 'Assessment',
  scenario: 'Scenario',
  rmp: 'Control',
  insights: 'Insights',
  dashboard: 'Dashboard',
};

const capitalize = (s: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s);

const safeParse = (raw?: string | null): Record<string, unknown> | null => {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? parsed : null;
  } catch {
    return null;
  }
};

export const toReportRow = (job: ExportJobRaw): ReportRow => {
  const params = safeParse(job.reportParams);
  const rawType = (job.reportType || '').toLowerCase();
  const objectLabel = OBJECT_LABEL_MAP[rawType] || capitalize(job.reportType || '-');

  const formatRaw = typeof params?.format === 'string' ? (params.format as string) : '';
  const formatLabel = formatRaw ? formatRaw.toUpperCase() : '-';

  return { ...job, objectLabel, formatLabel };
};
